<div *ngIf="!performer && !exhibitor && !resource && !attendee">Loading...</div>
<div class="briefView" [ngClass]="{publicView: publicView}" *ngIf="!!performer || !!exhibitor || !!resource || !!attendee">
  <h1>{{ eventTitle }}</h1>
  <h4>{{ entity.name }}</h4>
  
  <tip-text class="brief-tip" [type]="'important'" [head]="'Important'" [body]="'Refresh this page regularly to ensure you are viewing the latest information.'"></tip-text>
  <expanding-wrapper *ngIf="actions && !!actions.total && { remaining: actions.total - actions.submitted } as vars"
    class="actions"
    [warning]="!!vars.remaining"
    [title]="'Actions'"
    [borderGreyOnCollapse]="true"
  >
    <ng-container class="header-right">
      <div *ngIf="!vars.remaining && !nActionsIncomplete" class="complete">
        <icon [i18]="true" [icon]="'task_complete_24px'"></icon>
        All actions complete
      </div>
      <div *ngIf="!vars.remaining && !!nActionsIncomplete" class="complete">
        {{ nActionsIncomplete }} action{{ nActionsIncomplete === 1 ? '' : 's' }} in progress!
      </div>
      <div *ngIf="!!vars.remaining" class="required">
        {{ actions.submitted }} / {{ actions.total }} actions completed
      </div>
    </ng-container>
    <ng-container *ngIf="actions.profile as p">
      <h5>PROFILE</h5>
      <action-bar 
        [state]="openedActionUrls.has(p.baseUrl) ? 'inProgress' : p.submitted ? 'complete' : 'incomplete'" 
        [title]="'Edit your profile'"
        [incompleteText]="'EDIT PROFILE'"
        (buttonClick)="openActionUrl(p.baseUrl)"
      ></action-bar>
    </ng-container>

    <ng-container *ngIf="actions.associatedAssets as aa">
      <h5>ASSOCIATED ASSETS</h5>
      <action-bar 
        [state]="openedActionUrls.has(aa.baseUrl) ? 'inProgress' : aa.submitted ? 'complete' : 'incomplete'" 
        [title]="'Edit or Add Associated Assets'"
        [incompleteText]="'EDIT ASSOCIATED ASSETS'"
        (buttonClick)="openActionUrl(aa.baseUrl)"
      ></action-bar>
    </ng-container>

    <ng-container *ngIf="!!actions.sessions?.length">
      <h5>SESSIONS</h5>
      <grey-wrapper class="sessions" *ngFor="let s of actions.sessions">
        <h3>{{ s.title || 'Untitled session' }}</h3>
        <div class="grey-text">{{ s.subTitle }}</div>
        <action-bar
          *ngIf="s.synopsis as syn"
          [state]="openedActionUrls.has(syn.baseUrl) ? 'inProgress' : syn.submitted ? 'complete' : 'incomplete'" 
          [title]="'Edit/confirm session information'"
          [incompleteText]="'EDIT SESSION INFORMATION'"
          (buttonClick)="openActionUrl(syn.baseUrl)"
        ></action-bar>
        <action-bar
          *ngIf="s.staging as stg"
          [state]="openedActionUrls.has(stg.baseUrl) ? 'inProgress' : stg.submitted ? 'complete' : 'incomplete'" 
          [title]="'Add staging requests'"
          [incompleteText]="'ADD A STAGING REQUEST'"
          (buttonClick)="openActionUrl(stg.baseUrl)"
        ></action-bar>
      </grey-wrapper>
    </ng-container>

    <ng-container *ngIf="!!actions.quotes?.length">
      <h5>QUOTES</h5>
      <action-bar
        *ngFor="let a of actions.quotes"
        [state]="openedActionUrls.has(a.baseUrl) ? 'inProgress' : a.submitted ? 'complete' : 'incomplete'" 
        [title]="a.name || 'Unnamed Quote'"
        [incompleteText]="'SUBMIT QUOTE'"
        (buttonClick)="openActionUrl(a.baseUrl)"
      ></action-bar>
    </ng-container>

    <ng-container *ngIf="!!actions.standAssets?.length">
      <h5>EXHIBITOR STAND ASSETS</h5>
      <action-bar
        *ngFor="let a of actions.standAssets"
        [state]="openedActionUrls.has(a.baseUrl) ? 'inProgress' : a.submitted ? 'complete' : 'incomplete'" 
        [asset]="a"
        [incompleteText]="'EDIT ASSET'"
        (buttonClick)="openActionUrl(a.baseUrl)"
      ></action-bar>
    </ng-container>

    <ng-container *ngIf="!!actions.stands?.length">
      <h5>STANDS</h5>
      <grey-wrapper class="sessions" *ngFor="let s of actions.stands">
        <h3>{{ s.title || 'Untitled stand' }}</h3>
        <div class="grey-text">{{ s.subTitle }}</div>
        <action-bar
          *ngIf="s.staging as stg"
          [state]="openedActionUrls.has(stg.baseUrl) ? 'inProgress' : stg.submitted ? 'complete' : 'incomplete'" 
          [title]="'Add exhibitor stand requests'"
          [incompleteText]="'ADD AN EXHIBITOR STAND REQUEST'"
          (buttonClick)="openActionUrl(stg.baseUrl)"
        ></action-bar>
      </grey-wrapper>
    </ng-container>

    <h5 *ngIf="mediaTerms?.length">TERMS</h5>

    <ng-container *ngFor="let action of actions.terms">
      <action-bar 
        class="media-terms"
        *ngIf="mediaTerms | findById:action.id as terms"
        [ngClass]="{ app: !publicView }"
        [state]="action.submitted ? 'complete' : 'incomplete'" 
        [title]="terms.name || 'Terms'" 
        [incompleteText]="'ACCEPT'"
        [icon]="null"
        [completedText]="'Accepted'"
        (buttonClick)="!publicView ? null : acceptTerms(terms.id)"
      >
        <ng-container class="subtitle">
          <ng-container *ngIf="!action.submitted">I accept the <span [ngClass]="{ link: !!terms.url }" (click)="!terms.url ? null :  publicHelpers.openInNewTab(terms.url)">{{ terms.name || 'Terms' }}</span>.</ng-container>
          <ng-container *ngIf="action.submitted && !!terms.url"><span [ngClass]="{ link: !!terms.url }" (click)="!terms.url ? null :  publicHelpers.openInNewTab(terms.url)">{{ terms.name || 'Media terms' }}</span>.</ng-container>
        </ng-container>
      </action-bar>
    </ng-container>
  </expanding-wrapper>

  <expanding-wrapper
    class="performer-profile"
    [title]="!!performer ? 'Performer profile' : !!exhibitor ? 'Exhibitor details' : !!attendee ? 'Attendee profile' : 'Resource profile'"
    [borderGreyOnCollapse]="true"
    [bottomHeight]="publicView && showEditProfileButton ? '70px' : null"
  >
    <div class="section_content summary">
      <attendee-profile *ngIf="!!attendee" [attendee]="attendee"></attendee-profile>
      <performer-profile *ngIf="!!performer" [performer]="performer"></performer-profile>
      <exhibitor-profile *ngIf="!!exhibitor" [exhibitor]="exhibitor" ></exhibitor-profile>
      <resource-profile *ngIf="!!resource" [resource]="resource"></resource-profile>
      
      <ng-container *ngIf="!!exhibitor">
        <hr class="divider"/>
        <div class="subTitle">Exhibitor contact</div>
        <text-no-text [text]="exhibitor.contactName" [greyTitle]="'EXHIBITOR CONTACT NAME'" [placeholder]="'Exhibitor contact name...'"></text-no-text>
        <div class="thirds">
          <text-no-text [text]="exhibitor.contactNumber" [greyTitle]="'EXHIBITOR CONTACT PHONE'" [placeholder]="'Exhibitor contact phone...'"></text-no-text>
          <text-no-text [text]="exhibitor.contactEmail" [greyTitle]="'EXHIBITOR CONTACT EMAIL'" [placeholder]="'Exhibitor contact email...'"></text-no-text>
        </div>
      </ng-container>
    </div>
    <ng-container class="bottom" *ngIf="showEditProfileButton">
      <div style="flex:1;"></div>
      <div class="confirm-text">Edit your profile</div>
      <button mat-button color="primary" class="edit-profile-button" (click)="editProfileUrl.emit()">NEXT <icon [icon]="'OPEN_IN_NEW12'" i12=true></icon></button>
    </ng-container>
  </expanding-wrapper>

  <expanding-wrapper
    *ngIf="exhibitorSummaries?.length as s"
    [title]="'Stand summary'"
    [borderGreyOnCollapse]="true"
  >
    <div class="thirds summary" [ngClass]="{ divider: !first, first: first }" *ngFor="let s of exhibitorSummaries; first as first; last as last;">
      <text-no-text [text]="s.programName" [greyTitle]="'ROOM/LOCATION'" [placeholder]="'No room/location'"></text-no-text>
      <text-no-text [text]="s.standSize ? s.standSize.name : null" [greyTitle]="'STAND SIZE'" [placeholder]="'No stand size'"></text-no-text>
      <text-no-text [text]="s.standNumber" [greyTitle]="'STAND NUMBER'" [placeholder]="'No stand number'"></text-no-text>
      <text-no-text [text]="s.venueLocation" [greyTitle]="'VENUE ROOM/LOCATION'" [placeholder]="'No venue room/location'"></text-no-text>
      <text-no-text [text]="s.venueName" [greyTitle]="'VENUE NAME'" [placeholder]="'No venue name'"></text-no-text>
      <text-no-text [text]="s.venueAddress" [greyTitle]="'VENUE ADDRESS'" [placeholder]="'No venue address'"></text-no-text>
    </div>
  </expanding-wrapper>

  <expanding-wrapper
    [title]="(!!performer ? 'Performer' : !!exhibitor ? 'Exhibitor' : !!attendee ? 'Attendee' : 'Resource') + ' information for '+ entity.name + ' only'"
    [borderGreyOnCollapse]="true"
    *ngIf="!!singleEntityInformable && !!singleEntityInformable[0]?.items?.length"
  >
    <public-informable
      [information]="singleEntityInformable"
      [singleSectionOnly]="true"
    ></public-informable>
  </expanding-wrapper>
  
  <expanding-wrapper
    *ngIf="!!allEntityInformable && allEntityInformable[0]?.items?.length"
    [title]="capitalEntity + ' information'"
    [borderGreyOnCollapse]="true"
  ><public-informable [information]="allEntityInformable"></public-informable>
  </expanding-wrapper>

  <expanding-wrapper *ngIf="!!briefProgramPublishes?.length"
    class="publishes"
    [title]="'Program'"
    [borderGreyOnCollapse]="true"
  >
    <div class="link publish" *ngFor="let publish of briefProgramPublishes" (click)="openShare(publish.publishCode)">{{ publish.title }}<icon [i12]="true" [icon]="'OPEN_IN_NEW12'"></icon></div>
  </expanding-wrapper>

  <expanding-wrapper *ngIf="!!briefLogisticsViews?.length"
    class="publishes"
    [title]="'Production'"
    [borderGreyOnCollapse]="true"
  >
    <div class="link publish" *ngFor="let log of briefLogisticsViews" (click)="openShare('production/' + log.code)">{{ log.title }}<icon [i12]="true" [icon]="'OPEN_IN_NEW12'"></icon></div>
  </expanding-wrapper>

  <expanding-wrapper *ngIf="!!briefOnsiteViews?.length"
    class="publishes"
    [title]="'Onsite Schedules'"
    [borderGreyOnCollapse]="true"
  >
    <div class="link publish" *ngFor="let log of briefOnsiteViews" (click)="openShare('onsite/schedule/' + log.code)">{{ log.title }}<icon [i12]="true" [icon]="'OPEN_IN_NEW12'"></icon></div>
  </expanding-wrapper>


  <brief-timeline
    *ngIf="!!timeline?.length"
    [performers]="performers"
    [sponsors]="sponsors"
    [sponsorTypes]="sponsorTypes"
    [performer]="performer"
    [attendee]="attendee"
    [exhibitor]="exhibitor"
    [resource]="resource"
    [eventTitle]="eventTitle"
    [eventId]="eventId"
    [labelMaps]="labelMaps"
    [publicView]="publicView"
    [venues]="venues"
    [performerRoles]="performerRoles"
    [unavailable]="unavailable"
    [showActivityStatus]="showActivityStatus"
    [timeline]="timeline"
    [shareCode]="shareCode"
  ></brief-timeline>

  <expanding-wrapper
    class="performer-profile"
    *ngIf="!!workforceContactProfile"
    [title]="'Workforce Contact'"
    [borderGreyOnCollapse]="true"
  >
    <div class="section_content summary">
      <div class="contact-inactive" *ngIf="!!workforceContactInactive">
        Workforce contact details not available yet
      </div>
      <workforce-contact-profile *ngIf="!workforceContactInactive" [contact]="workforceContactProfile"></workforce-contact-profile>
    </div>
  </expanding-wrapper>

</div>